import api from "../../database";
import { IAnnouncement } from "../../../announcements";

export const getNews = async (token: string): Promise<IAnnouncement[]> => {
  const response = await api.get("/announcements/active", {
    headers: {
      "x-access-token": token,
    },
  });

  return response.data;
};
